export enum TaskState {
  TaskStateComplete = "completed",
  TaskStateClosed = "closed",
  TaskStatePending = "pending",
}

// Except for the TaskType and TaskState types the types defined below also exists in cmp-fixa.
export enum TaskMessageType {
  TaskMessageAssignedUser = "task-message-assigned-user",
  TaskMessageAssignedTeam = "task-message-assigned-team",
  TaskMessageCreatorTaskStatusCompleted = "task-message-creator-task-status-completed",
  TaskMessageCreatorTaskStatusClosed = "task-message-creator-task-status-closed",
  TaskMessageCreatorAssignedUser = "task-message-creator-assigned-user",
  TaskMessageCreatorAssignedTeam = "task-message-creator-assigned-team",
  TaskMessageCreatorUserPickup = "task-message-creator-user-pickup",
  TaskMessageCreatorSeriesEnd = "task-message-creator-series-end",
  TaskMessageCreatorSeriesUpdate = "task-message-creator-series-update",
  TaskMessageCreatorSeriesClose = "task-message-creator-series-close",
}
interface ComponentType {
  type: string;
  props: object;
  components?: ComponentType[];
}

export interface UserType {
  userId: string;
  firstName: string;
  lastName: string;
  fullName: string;
}

export interface TeamType {
  teamId: string;
  name: string;
}

export function isUserType(
  userOrTeam: UserType | TeamType
): userOrTeam is UserType {
  return "userId" in userOrTeam;
}

export interface ItemInfoType {
  id: string;
  name: string;
  imageUrl: string;
  type: "ART" | "SPR" | "SCI";
}

export interface ComponentNotificationTitleAssigned extends ComponentType {
  type: "notification-title-assigned";
  props: {
    assignedBy: UserType;
    assignedTo: UserType | TeamType;
  };
}

export interface ComponentNotificationTitleCreatorUserPickup extends ComponentType {
  type: "notification-title-creator-user-pickup";
  props: {
    assignedBy: UserType;
  };
}

export interface ComponentNotificationTitleCreatorStatus extends ComponentType {
  type: "notification-title-creator-status";
  props: {
    status: `${TaskState}`;
    statusChangeBy: UserType;
  };
}

export interface ComponentNotificationTitleCreatorAssigned extends ComponentType {
  type: "notification-title-creator-assigned";
  props: {
    assignedBy: UserType;
  };
}

export interface ComponentNotificationTitleSeriesEnd extends ComponentType {
  type: "notification-title-series-end";
  props: Record<string, never>;
}

export interface ComponentNotificationTitleSeriesUpdate extends ComponentType {
  type: "notification-title-series-update";
  props: {
    updatedBy: UserType;
  };
}

export interface ComponentNotificationTitleSeriesClose extends ComponentType {
  type: "notification-title-series-close";
  props: {
    closedBy: UserType;
  };
}

export type ComponentNotificationTitle =
  | ComponentNotificationTitleAssigned
  | ComponentNotificationTitleCreatorUserPickup
  | ComponentNotificationTitleCreatorStatus
  | ComponentNotificationTitleCreatorAssigned
  | ComponentNotificationTitleSeriesEnd
  | ComponentNotificationTitleSeriesUpdate
  | ComponentNotificationTitleSeriesClose;

export interface NotificationTranslationKeyType {
  options?: object;
  key: string;
}

export interface ComponentNotificationBodyTaskTitleAndDescription extends ComponentType {
  type: "notification-body-title-and-description";
  props: {
    priority: boolean;
    safety: boolean;
    status: `${TaskState}`;
    title: string | NotificationTranslationKeyType;
    description: string;
  };
}
export interface ComponentNotificationBodyProduct extends ComponentType {
  type: "notification-body-product";
  props: {
    priority: boolean;
    safety: boolean;
    status: `${TaskState}`;
    itemInfo: ItemInfoType | null;
  };
}
export interface ComponentNotificationBodyAssignedTitle extends ComponentType {
  type: "notification-body-assigned-title";
  props: {
    title: string | NotificationTranslationKeyType;
    oldAssignedTo: UserType | TeamType;
    newAssignedTo: UserType | TeamType;
  };
}
export interface ComponentNotificationBodyAssignedProduct extends ComponentType {
  type: "notification-body-assigned-product";
  props: {
    itemInfo: ItemInfoType | null;
    oldAssignedTo: UserType | TeamType;
    newAssignedTo: UserType | TeamType;
  };
}
export type ComponentNotificationBody =
  | ComponentNotificationBodyTaskTitleAndDescription
  | ComponentNotificationBodyProduct
  | ComponentNotificationBodyAssignedTitle
  | ComponentNotificationBodyAssignedProduct;

export interface ComponentNotificationFooter extends ComponentType {
  type: "notification-footer";
  props: {
    taskLabel: string;
  };
}

export interface ComponentNotificationTaskType extends ComponentType {
  type: `${TaskMessageType}`;
  props: {
    taskId: string;
  };
  components: [
    ComponentNotificationTitle,
    ComponentNotificationBody,
    ComponentNotificationFooter,
  ];
}
